import { Protocol } from '../Protocol';

export class proportionMaintenanceMixerProtocol {
  public static readonly GET_PROPORTION_MAINTENANCE_MIXER_ALL: string = `${Protocol.YATUNG_API_ROOT}/proportion/maintenance/mixer/all`;
  public static readonly GET_PROPORTION_OPTIONS: string = `${Protocol.YATUNG_API_ROOT}/proportion/option/all`;
}
